import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/#about' },
    { name: 'Products', path: '/#products' },
    { name: 'Quality', path: '/quality' },
    { name: 'Sustainability', path: '/sustainability' },
    { name: 'Contact', path: '/#contact' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h2 className="footer-logo">we2 exporters</h2>
            <p className="footer-tagline">Exporting Quality Agro Products Worldwide</p>
          </div>

          <div className="footer-links">
            {footerLinks.map((link, index) => (
              <React.Fragment key={index}>
                <Link to={link.path} className="footer-link">
                  {link.name}
                </Link>
                {index < footerLinks.length - 1 && <span className="footer-separator">|</span>}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} we2 exporters. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
